import { useGroupsAndUsersStore } from '@/ContextTab/stores/groupsAndUsers'
import { processGroupsAndUsersForLegacy } from '@/lib/processDataForLegacy'


export function usePassUsers() {

  const groupsAndUsersStore = useGroupsAndUsersStore()

  return async (legacyApp: any) => {
    await legacyApp.$store.dispatch(
      'setGroupsAndUsers',
      processGroupsAndUsersForLegacy(groupsAndUsersStore.groupsAndUsers),
    )
  }
}
